import React from 'react';
import SectionHead from 'ui-components/SectionHead';
import { showTable, sortClients } from 'utils/utils';
import ClientsTable from '../clients-table/ClientsTable';

import './non-direct-clients.scss';

const NonDirectClients = ({clients}) => {
    
    return (
        <div className="non-direct-clients">
            <SectionHead head={"Non Direct"}/>
            {
                showTable(clients.active) &&
                    <ClientsTable 
                        clientsData={sortClients(clients.active)} 
                        tableHead={"Active Clients"}
                    />
            }
            {
                showTable(clients.deactivated) &&
                    <ClientsTable 
                        clientsData={sortClients(clients.deactivated)} 
                        tableHead={"Deactivated clients"} 
                        isDeactivated={true}
                    />
            }
            
        </div>
    );
};

export default NonDirectClients;